import { DeactivateTechnician } from './DeactivateTechnician';
/**
 * The states worth seeing side by side are the ones where the copy has to change shape: both
 * counts present, one of them zero, and a volume large enough that the move is backgrounded and
 * the dialog has to say so.
 *
 * `markInactiveUrl` is inert in Storybook — confirming builds and submits a real form, so these
 * stories are for the dialog, not for the submit.
 */
const meta = {
    title: 'Features/Settings/Technicians/DeactivateTechnician',
    component: DeactivateTechnician,
    parameters: { layout: 'centered' }
};
export default meta;
const destinations = [
    { id: 1, name: 'Padraic Doyle' },
    { id: 4, name: 'Jennifer' },
    { id: 19, name: 'nick4' }
];
export const BothRecordTypes = {
    args: {
        technicianName: 'ipj',
        counts: { inspections: 6, workOrders: 2 },
        destinations,
        markInactiveUrl: '/technicians/159/mark_inactive',
        backgroundThreshold: 50
    }
};
/** The case that catches a wrong pluralisation: "no open inspections and 1 open work order". */
export const OneTypeAtZero = {
    args: Object.assign(Object.assign({}, BothRecordTypes.args), { technicianName: 'pedro', counts: { inspections: 0, workOrders: 1 } })
};
/** Above the threshold the dialog warns that the move happens in the background. */
export const LargeEnoughToBackground = {
    args: Object.assign(Object.assign({}, BothRecordTypes.args), { technicianName: 'Nick Dibble', counts: { inspections: 6720, workOrders: 181 } })
};
/** A long list turns the select's search on — 131 of 145 technicians are available on tenant 5. */
export const ManyDestinations = {
    args: Object.assign(Object.assign({}, BothRecordTypes.args), { destinations: Array.from({ length: 40 }, (_, index) => ({
            id: index + 1,
            name: `Technician ${index + 1}`
        })) })
};
